import { Heading, VStack } from '@chakra-ui/react';
import React from 'react';

const TARMContainer = ({ heading, children }) => {
  return (
    <VStack spacing={4} align="center">
      <Heading>{heading}</Heading>
      {children}
    </VStack>
  );
};

export default TARMContainer;
